import { getError } from "@/utils/get-error";
import { axiosInstance } from "@dexteel/mesf-core";
import { Axios } from "axios";
import { WorkerType } from "../models/WorkerType";

export class WorkerTypesRepository {
	private axios: Axios;

	constructor(token?: string) {
		this.axios = axiosInstance;

		this.getWorkerTypes = this.getWorkerTypes.bind(this);
		this.getWorkerTypeById = this.getWorkerTypeById.bind(this);
		this.createWorkerType = this.createWorkerType.bind(this);
		this.updateWorkerType = this.updateWorkerType.bind(this);
		this.deleteWorkerType = this.deleteWorkerType.bind(this);
	}

	async getWorkerTypes() {
		try {
			const resp = await this.axios.get("/WorkerType/");
			return {
				ok: true,
				data: resp,
			};
		} catch (error: any) {
			const message = getError(error);
			return Promise.reject(message);
		}
	}

	async getWorkerTypeById(workerTypeId: number | null) {
		try {
			const resp = await this.axios.get(`/WorkerType/${workerTypeId}`);

			return {
				ok: true,
				data: resp.data,
			};
		} catch (e: any) {
			return { ok: false, message: e.toString() };
		}
	}

	async createWorkerType(workerTypeData: WorkerType) {
		try {
			const resp = await this.axios.post("/WorkerType/", {
				workerTypeName: workerTypeData.workerTypeName,
				workerTypeId: 6 /* workerData.workerTypeId == 0 ? 4 : workerData.workerTypeId */,
			});
			return {
				ok: true,
				resp,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}

	async updateWorkerType(
		workerTypeId: number | null,
		workerTypedata: WorkerType,
	) {
		try {
			const resp = await this.axios.patch(
				`/WorkerType/${workerTypeId}`,
				workerTypedata,
			);
			return {
				ok: true,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}

	async deleteWorkerType(workerTypeId: number | null) {
		try {
			const resp = await this.axios.delete("/WorkerType/", {
				params: { workerTypeId },
			});
			return {
				ok: true,
				resp,
			};
		} catch (error: any) {
			const message = getError(error);
			return Promise.reject(message);
		}
	}
}

export const {
	getWorkerTypes,
	getWorkerTypeById,
	createWorkerType,
	updateWorkerType,
	deleteWorkerType,
} = new WorkerTypesRepository();
